import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, WidthType } from "docx";

export const tools = new Paragraph({
    indent: { left: 600, },
    spacing: { before: 100, after: 150 },
    children: [
        new TextRun({
            text: "External framework and tools used for Penetration Test",
            size: 24,
            color: "003366",
            font: "Calibri",
            bold: true,
            italics: false
        })
    ],
})


export const toolsTable = new Table({
    width: { size: 89, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 1200 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
    },

    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 12, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Sl. No",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "0189f9" },
                    indent: { left: 600 },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    width: { size: 30, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Frameworks /Methodologies",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "0189f9",
                    },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    width: { size: 58, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "References",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "0189f9",
                    },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "OWASP Compliance Standards",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "https://www.owasp.org/index.php/Category:OWASP_Top_Ten_Project",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    columnSpan: 2,
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Tools",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "E4E4E4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "References",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    bold: true,
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "E4E4E4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),

        // new TableRow({
        //     children: [
        //         new TableCell({
        //             columnSpan: 3,
        //             children: [
        //                 new Paragraph({
        //                     spacing: { before: 80, after: 80 },
        //                     indent: { left: 100 },
        //                     alignment: AlignmentType.LEFT,
        //                     children: [
        //                         new TextRun({
        //                             text: "Vulnerability Scanners",
        //                             font: "Calibri",
        //                             size: 22,
        //                             color: '0f0f3f',
        //                             italics: false
        //                         })
        //                     ]
        //                 })],
        //             shading: { type: ShadingType.SOLID, color: "CBE7FE" },
        //             borders: {
        //                 top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        //                 bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        //                 left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        //                 right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        //             },
        //         }),
        //     ]
        // }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "2",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Genymotion",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "https://www.genymotion.com/",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "3",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Magsik Manger",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "https://magiskmanager.com/",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),

        // new TableRow({
        //     children: [
        //         new TableCell({
        //             columnSpan: 3,
        //             children: [
        //                 new Paragraph({
        //                     spacing: { before: 80, after: 80 },
        //                     indent: { left: 100 },
        //                     alignment: AlignmentType.LEFT,
        //                     children: [
        //                         new TextRun({
        //                             text: "Penetration Testing Tools",
        //                             font: "Calibri",
        //                             size: 22,
        //                             color: '0f0f3f',
        //                             italics: false
        //                         })
        //                     ]
        //                 })],
        //             shading: { type: ShadingType.SOLID, color: "CBE7FE" },
        //             borders: {
        //                 top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        //                 bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        //                 left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        //                 right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        //             },
        //         }),
        //     ]
        // }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "4",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "MobSF",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false,

                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "https://github.com/MobSF/Mobile-Security-Framework-MobSF",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "5",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Dex2jar",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false,

                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "https://github.com/pxb1988/dex2jar",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "6",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "JD-JUI",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "JD-JUI	https://github.com/java-decompiler/jd-gui",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "7",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Frida",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false,

                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "https://github.com/frida/frida/",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "ffffff" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "8",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Burpsuite Pro",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "https://portswigger.net/burp",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
            ]
        }),
    ]
})